import axios from "axios";
import { baseURL, headersTok } from "@/general";

const adminApi = axios.create({
  baseURL,
});

export const LoginUser = async (values) => {
  try {
    const response = await adminApi.post("/general/login", values);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const GetUserRecords = async (values) => {
  const token = sessionStorage.getItem('token');
  const headers = headersTok({ tok: token, accion: 'POST' });
  try {
    const response = await adminApi.post("/registro/registrosByPeriodo", values, headers);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const GetDataCatalog = async (values) => {
  const token = sessionStorage.getItem('token');
  const headers = headersTok({ tok: token, accion: 'POST' });
  const catalogo = values.catalogo;
  try {
    const response = await adminApi.post(`/catalogo/${catalogo}`, {}, headers);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const GetDatosPersonales = async (values) => {
  const token = sessionStorage.getItem('token');
  const headers = headersTok({ tok: token, accion: 'POST' });
  try {
    const response = await adminApi.post("/alumno/datosAlumno", values, headers);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const insertAlumnoService = async (values) => {
  const token = sessionStorage.getItem('token');
  const headers = headersTok({ tok: token, accion: 'POST' });
  try {
    const response = await adminApi.post("/alumno/registroSolicitud", values, headers);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const generarComprobanteService = async (values) => {
  const token = sessionStorage.getItem('token');
  const headers = headersTok({ tok: token, accion: 'POST' });
  try {
    const response = await adminApi.post("/general/generarComprobante", values, headers);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const registraDocumentosService = async (values) => {
  const token = sessionStorage.getItem('token');
  // const headers = headersTok({ tok: token, accion: 'POST' });
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post("/alumno/registroDocumentacion", values, config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const consultaDocumentosService = async (values) => {
  const token = sessionStorage.getItem('token');
  const headers = headersTok({ tok: token, accion: 'POST' });
  try {
    const response = await adminApi.post("/alumno/documentacion", values, headers);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};